import { render, staticRenderFns } from "./PollMatrixEditorCompact.vue?vue&type=template&id=bfc80b64&scoped=true"
import script from "./PollMatrixEditorCompact.vue?vue&type=script&lang=js"
export * from "./PollMatrixEditorCompact.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixEditorCompact.vue?vue&type=style&index=0&id=bfc80b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc80b64",
  null
  
)

export default component.exports